import { render, staticRenderFns } from "./TranslationCellRenderer.vue?vue&type=template&id=7e090364&"
import script from "./TranslationCellRenderer.vue?vue&type=script&lang=js&"
export * from "./TranslationCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports